// HighTrafficModal helper functions and data

export const backdropConfig = {
  opacity: 0.6,
  className: "HighTrafficModal__backdrop",
  borderRadius: 40
};
